import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  LineChart,
  Line,
} from "recharts";
import {
  getBusinessContributionDataByDate,
  getBusinessAtsChartDataByDate,
  getLiveReportDailyTrendByDate,
  getMArketingPerformanceStatsByDate,
} from "../../ActionCreator";
import { useEffect, useState } from "react";
import moment from "moment";
import Loader from '../../../../../presentationals/Loader/Loader.component'

const Business = ({ appliedDate }) => {
  const sDate = appliedDate?.from
    ? moment(appliedDate.from).format("DD-MM-YYYY")
    : "";
  const eDate = appliedDate?.to
    ? moment(appliedDate.to).format("DD-MM-YYYY")
    : "";

  const [isLoading, setIsLoading] = useState(false);
  const [dailyTrendData, setDailyTrendData] = useState([]);
  const [atsData, setAtsData] = useState([]);
  const [businessContriData, setBusinessContriData] = useState([]);
  const [statsData, setStatsData] = useState();


  const getStatsData = () => {
    setIsLoading(true);
    getMArketingPerformanceStatsByDate(sDate, eDate, (res) => {
      setIsLoading(false);
      setStatsData(res?.data);
    });
  };

  const getMonthlyBusinessChartData = () => {
    setIsLoading(true);
    getLiveReportDailyTrendByDate(sDate, eDate, "monthly", (res) => {
      setIsLoading(false);
      setDailyTrendData(res?.data);
    });
  };

  const getBusinessContriChartData = () => {
    setIsLoading(true);
    getBusinessContributionDataByDate(sDate, eDate, (res) => {
      setIsLoading(false);
      setBusinessContriData(res?.data);
    });
  };

  const getAtsData = () => {
    setIsLoading(true);
    getBusinessAtsChartDataByDate(sDate, eDate, (res) => {
      setIsLoading(false);
      setAtsData(res?.data);
    });
  };

  useEffect(() => {
    getStatsData();
    getMonthlyBusinessChartData();
    getBusinessContriChartData();
    getAtsData();
  }, [appliedDate]);

  const aggregatorNames =
    businessContriData?.[0]?.aggregators?.map((a) => a.aggregatorName) || [];

  const formattedData = businessContriData?.map((item) => {
    const obj = {
      monthName: item.monthName,
    };

    item?.aggregators?.forEach((agg) => {
      obj[agg.aggregatorName] = agg.disbursementCount;
    });

    return obj;
  });

  return (
    <div className=" business-dashboard">
      {
        isLoading ? <Loader /> : <>
          <div className="row g-4">
        <div className="col-md-4">
          <div className="card-box">
            <p>Current Month Business</p>
            <h3 className="blue">{statsData?.[0]?.totalDisbursementAmount}</h3>
            <span
              style={{
                color: "#4FA564",
              }}
            >
              {/* {summary.growth} vs last month */}
            </span>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card-box">
            <p>Total Disbursement Leads</p>
            <h3
              style={{
                color: "#4FA564",
              }}
            >
              {statsData?.[0]?.totalDisbursedLeads}
            </h3>
            {/* <span>This Month</span> */}
          </div>
        </div>

        <div className="col-md-4">
          <div className="card-box">
            <p>Average Ticket Size</p>
            <h3
              style={{
                color: "#8A38F5",
              }}
            >
              {statsData?.[0]?.ats}
            </h3>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12" style={{ marginTop: "50px" }}>
          <div className="card-box">
            <h5
              style={{
                fontSize: "16px",
                fontWeight: 600,
                marginTop: "0px",
                marginBottom: "14px",
              }}
            >
              Business Contribution by Aggregator
            </h5>

            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={formattedData}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} />

                <XAxis
                  dataKey="monthName"
                  axisLine={{ stroke: "#0000001f", strokeWidth: 1 }}
                />
                <YAxis axisLine={{ stroke: "#0000001f", strokeWidth: 1 }} />
                <Tooltip />

                {aggregatorNames.map((name, index) => (
                  <Bar
                    key={name}
                    dataKey={name}
                    stackId="a"
                    fill={
                      [
                        "#1E88E5",
                        "#2E7D32",
                        "#F59E0B",
                        "#8E24AA",
                        "#D81B60",
                        "#00897B",
                      ][index % 6]
                    }
                  />
                ))}
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      <div className="row g-4">
        <div className="col-md-6" style={{ marginTop: "60px" }}>
          <div className="card-box">
            <h5
              style={{
                fontSize: "16px",
                fontWeight: 600,
                marginTop: "0px",
                marginBottom: "14px",
              }}
            >
              ATS Metrics
            </h5>

            <ResponsiveContainer width="100%" height={250}>
              <BarChart data={atsData}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis
                  dataKey="range"
                  axisLine={{ stroke: "#0000001f", strokeWidth: 1 }}
                />
                <YAxis axisLine={{ stroke: "#0000001f", strokeWidth: 1 }} />
                <Tooltip />
                <Bar dataKey="disbursementCount" fill="#7C4DFF" />
              </BarChart>
            </ResponsiveContainer>

            <div className="info purple-bg">
              💡 Most common ticket size: ₹25K–50K (38.7%)
            </div>
          </div>
        </div>

        <div className="col-md-6" style={{ marginTop: "60px" }}>
          <div className="card-box">
            <h5
              style={{
                fontSize: "16px",
                fontWeight: 600,
                marginTop: "0px",
                marginBottom: "14px",
              }}
            >
              Monthly Business Trend
            </h5>

            <ResponsiveContainer width="100%" height={250}>
              <LineChart data={dailyTrendData}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis
                  dataKey="monthName"
                  axisLine={{ stroke: "#0000001f", strokeWidth: 1 }}
                />
                <YAxis axisLine={{ stroke: "#0000001f", strokeWidth: 1 }} />
                <Tooltip />
                <Line
                  dataKey="disbursementAmount"
                  stroke="#2E7D32"
                  strokeWidth={2}
                  dot={{ r: 5 }}
                />
              </LineChart>
            </ResponsiveContainer>

            <div className="info green-bg">
              📊 Consistent growth trend: 60% increase from Aug to Jan
            </div>
          </div>
        </div>
      </div>
        </>
      }
    
    </div>
  );
};

export default Business;
